import PropTypes from 'prop-types';
import FJPhotoRemoveBgAutoLeft from '../view/FJPhotoRemoveBgAutoLeft';
import { useDispatch } from 'react-redux';
import FJActionPhotoBgRemover from '../../../../redux/action/FJActionPhotoBgRemover';
import { useSelector } from 'react-redux';
import { USE_CREDIT } from '../../../../redux/slices/FJSlicePhotoBgRemover';
import { useMemo } from 'react';
import FJConstant from '../../../../constants/FJConstant';
import { useCallback } from 'react';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';

const FJPhotoRemoveBgAutoLeftContainer = props => {
    useLocalStore();
    const { isShow } = props;

    const dispatch = useDispatch();

    const isNotImage = useSelector(state => state.photoBgRemover.autoBgImageDataList.length === 0);
    const isPhotoRemoveBg = useSelector(state => state.brushEditCommon.isPhotoRemoveBg);
    const freeNumCreation = useSelector(state => state.photoBgRemover.autoBackgroundRemoveFreeNum);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const brushEditStatus = useSelector(state => state.brushEditCommon.brushEditStatus);
    const autoBgImageDataList = useSelector(state => state.photoBgRemover.autoBgImageDataList);

    const displayUploadFile = useMemo(() => {
        return (
            brushEditStatus === FJConstant.START ||
            autoBgImageDataList.some(item => item.taskStatus === FJConstant.START)
        );
    }, [brushEditStatus, autoBgImageDataList]);

    const isFree = freeNumCreation > 0 && USE_CREDIT > creditNumber;

    const uploadAutoBgImage = useCallback(
        files => {
            if (displayUploadFile) return;
            dispatch(FJActionPhotoBgRemover.uploadAutoBgImageFile(files));
        },
        [dispatch, displayUploadFile],
    );

    const _openMediaLibrary = () => {
        dispatch(FJActionEditPage.openMediaLibraryAction({ canMultipleChoose: true }));
    };

    return (
        <FJPhotoRemoveBgAutoLeft
            isShow={isShow}
            uploadAutoBgImage={uploadAutoBgImage}
            isNotImage={isNotImage}
            isPhotoRemoveBg={isPhotoRemoveBg}
            freeNumCreation={freeNumCreation}
            isFree={isFree}
            useCredit={USE_CREDIT}
            displayUploadFile={displayUploadFile}
            openMediaLibrary={_openMediaLibrary}
        />
    );
};

FJPhotoRemoveBgAutoLeftContainer.propTypes = {
    isShow: PropTypes.bool,
};

export default FJPhotoRemoveBgAutoLeftContainer;
